import f from "@ui-kit/components/modal";
import E from "@ui-kit/components/button";
import { defineComponent as b, ref as I, resolveComponent as y, openBlock as h, createElementBlock as M, createVNode as a, unref as t, withCtx as v, createBlock as A } from "vue";
import { faXmark as B } from "@fortawesome/pro-regular-svg-icons";
import { useCurrentProviderKey as S, useProviderI18n as j } from "@versatile-credit-apply/sdk";
import { useSessionTimeout as T } from "@versatile-credit-apply/composition";
import { useEventListener as U } from "@vueuse/core";
import { useI18n as V } from "vue-i18n";
const g = /* @__PURE__ */ b({
  __name: "FlowExitButton",
  emits: ["exit"],
  setup(n, { emit: e }) {
    const i = I(!1), l = () => i.value = !0, r = S(), { t: o } = j(r), s = e, c = () => s("exit");
    return (u, _) => {
      const x = E, w = y("i18n-t"), k = f;
      return h(), M("div", null, [
        a(x, {
          icon: t(B),
          severity: "secondary",
          text: "",
          class: "text-xl focus:ring-1",
          onClick: l
        }, null, 8, ["icon"]),
        a(k, {
          modelValue: i.value,
          "onUpdate:modelValue": _[0] || (_[0] = (C) => i.value = C),
          severity: "error",
          header: t(o)("confirm_cancel_heading"),
          "cancel-button-label": t(o)("confirm_modal_reject"),
          "accept-button-label": t(o)("confirm_modal_accept"),
          onModalAccept: c
        }, {
          default: v(() => [
            a(w, {
              keypath: "confirm_cancel_message",
              tag: "p"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "header", "cancel-button-label", "accept-button-label"])
      ]);
    };
  }
});
function m(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      confirm_cancel_heading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Exit Application?
` } },
      confirm_cancel_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This will end your current application session." } },
      confirm_modal_accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes Exit" } },
      confirm_modal_reject: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
    }
  });
}
function p(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      confirm_cancel_heading: { t: 0, b: { static: "", t: 2, i: [] } },
      confirm_cancel_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Are you sure you don't want to apply? If you leave the credit application now, all the info you've entered will be lost.
` } },
      confirm_modal_accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes, I'm Sure" } },
      confirm_modal_reject: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Keep Applying" } }
    }
  });
}
typeof m == "function" && m(g);
typeof p == "function" && p(g);
const $ = /* @__PURE__ */ b({
  __name: "SessionTimeoutModal",
  setup(n) {
    const { t: e } = V(), { reset: i, displayWarning: l } = T();
    return U(
      document,
      ["keydown", "keyup", "mousedown", "mouseup", "mousemove"],
      () => {
        l.value || i(!1);
      }
    ), (r, o) => {
      const s = y("i18n-t"), c = f;
      return h(), A(c, {
        "model-value": t(l),
        severity: "warning",
        header: t(e)("session.timeout_warning.heading"),
        "accept-button-label": t(e)("actions.still_here.label"),
        "cancel-button-label": t(e)("actions.exit.label"),
        onModalAccept: o[0] || (o[0] = (u) => t(i)(!1)),
        onModalReject: o[1] || (o[1] = (u) => t(i)(!0))
      }, {
        default: v(() => [
          a(s, {
            keypath: "session.timeout_warning.message",
            tag: "p"
          })
        ]),
        _: 1
      }, 8, ["model-value", "header", "accept-button-label", "cancel-button-label"]);
    };
  }
});
function d(n) {
  const e = n;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      actions: {
        exit: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit" } }
        },
        still_here: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Still Here" } }
        }
      },
      session: {
        timeout_warning: {
          heading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Are you still there?" } },
          message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `You are about to be timed out which will clear all of your
personal information from the device and exit the session.
` } }
        }
      }
    }
  });
}
typeof d == "function" && d($);
export {
  g as FlowExitButton,
  $ as SessionTimeoutModal
};
//# sourceMappingURL=index.es.js.map
